import { v4 } from 'uuid'

import { FormItemDraggableBase } from './form-item-draggable-base'
import { IconEnum } from '../../../../../assets/icons'
import { FormItemType } from '../../constants/form-builder.constants'

export const RadioDraggable = () => {
  const id = v4()
  const type = FormItemType.Radio

  return (
    <FormItemDraggableBase
      icon={IconEnum.DotRounded}
      id={id}
      title="formBuilder.radio"
      type={type}
    />
  )
}
